export default __webpack_public_path__ + "static/media/buffer.d19ad80d.png";